import React from 'react'
import { useTranslation } from 'react-i18next'
import CellEditor, { type CellMove } from './CellEditor'

interface Props {
  value: string
  min: number
  max: number
  errorKey: string
  onCommit: (v: string, move: CellMove) => void
  onCancel: () => void
}

/** A whole-number cell (`duration`, `percent` — spec B §9.3): integer, right-aligned, bounded by `[min, max]`. */
const IntCell: React.FC<Props> = ({ value, min, max, errorKey, onCommit, onCancel }) => {
  const { t } = useTranslation()
  return (
    <CellEditor
      initial={value}
      align="right"
      validate={(v) => {
        const trimmed = v.trim()
        if (!/^-?\d+$/.test(trimmed)) return t(errorKey)
        const n = Number(trimmed)
        return n < min || n > max ? t(errorKey) : null
      }}
      onCommit={onCommit}
      onCancel={onCancel}
    />
  )
}

export default IntCell
